export const register = {
  field: {
    currency: 'Валюта',
    email: 'Адрес электронной почты',
    phone_number: 'Номер телефона',
    terms: 'Условия и Соглашения'
  },
  button: {
    check_code: 'Подтвердить',
    continue: 'Продолжить',
    create_account: 'Создать аккаунт',
    new_code: 'Новый код',
    recovery_password: 'Восстановить пароль',
    register: 'Зарегистрироваться',
    use_different_number: 'Использовать другой номер телефона',
    change_number: 'Изменить номер',
    resend: 'Отправить'
  },
  error: {
    1001: 'Превышен лимит запросов SMS-кодов в минуту, попробуйте позже',
    1002: 'Превышен лимит запросов SMS-кодов в час, попробуйте позже',
    1003: 'Не найден запрос на подтверждение номера',
    1004: 'Превышен лимит попыток, запросите новый код подтверждения',
    1005: 'Неверный код подтверждения',
    something_went_wrong: 'Что-то пошло не так',
    email: 'Адрес электронной почты уже занят.',
    phone: 'Телефон уже занят.'
  },
  modal: {
    registration_successfully: 'Регистрация прошла успешно',
    registration_successfully_text: `<span style="display: block">Спасибо за регистрацию.</span>
      <span>Данные для входа отправлены вам на email.</span>`
  },
  confirm: {
    title: 'Подтверждение',
    text: 'Мы отправили код подтверждения на номер',
    sending_sms: 'Отправка СМС',
    change_number_text: 'Вы уверены, что хотите повторно отправить код подтверждения на номер',
    acc_configured: `Настраиваем аккаунт. <br> Это займет не больше минуты`
  },
  events: {
    welcome: `Благодарим вас за регистрацию! <br> На указанную почту было отправлено письмо с данными для входа в аккаунт. <br>Вам был начислен приветственный баланс 20 рублей.`,
    fail: `Во время регистрации произошла ошибка. <br>Дополнительная информация отправлена на указанный email.`,
    timeout: `Во время регистрации произошла ошибка.<br>Пожалуйста, свяжитесь с нашей командой поддержки. <br>Мы поможем решить вашу проблему.`
  },
  change_not_possible: 'Внести изменения позже будет невозможно',
  choose_currency:
    'Выберите валюту, в которой вам будет удобнее проводить расчеты, получать статистику и финансовые отчеты.',
  email_address: 'Адрес электронной почты',
  i_agree: 'Я согласен с ',
  log_in: 'На страницу авторизации',
  phone_verified: 'Номер телефона подтвержден',
  phone_verify_code: 'SMS-код подтверждения',
  terms_and_conditions: 'Условиями и Положениями',
  have_acc: 'У вас есть аккаунт?',
  private_registration_title: 'Приватная регистрация',
  private_registration_text: 'Напишите нам, чтобы зарегистрировать аккаунт',
  private_registration_button: 'Связаться с нами'
};
